<div class="row">
  <div class="col-12 p-0">
    <div class="row border Page-Header">
      <div class="col-8">
        <h6 class="px-2 mt-2"><strong>Subject Management : </strong> Add/Edit Topic</h6>
      </div>
      <div class="col-4">
        <div class="d-flex flex-row-reverse">
          <div class="px-1">
            <button type="button" class="btn btn-sm bl-btn border">Refresh</button>
          </div>
          <div class="px-2">
            <select  class="form-control form-control-sm"  [(ngModel)]="appser.userlanuage">
              <option *ngFor="let d of lanuage" [ngValue]="d"> {{d}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 px-1">
    <div class="row border-bottom">
      <div class="col-2 py-2">
        <select  class="form-control form-control-sm"
        (change)="SelectSubject($event)">
          <option selected value="0" hidden>Select Subject</option>
          <option class="border-bottom" *ngFor="let s of subject;let i=index" [value]="s.ID"> {{s.Name}}</option>
        </select>
      </div>
    </div>
    <div class="row pt-3 scrollable-box">
      <app-tree-add-btn *ngIf="MajorTopic.length==0 && selectedsubject" Text="Add Major Topic" [Primary]=true (click)="addNewConcept(MajorTopic,'MT',null)">
      </app-tree-add-btn>
      <div class="col-12" style="overflow: hidden;" *ngIf="MajorTopic.length>0">
        <app-tree-add-btn Text="Add Major Topic" [Primary]=true (click)="addNewConcept(MajorTopic,'MT',null)">
        </app-tree-add-btn>
        <div class="row tree-row" *ngFor="let MT of MajorTopic;let i=index"
          (mouseenter)="OnSelect(MT.ID,MT.Subject_Level_Type_Code)">
          <div class="col-12 d-flex">
            <div class="px-1 tree-btn-1">
              <button type="button" class="tree-btn" attr.id="plusMT{{i}}" [hidden]="MT.ChildNodeExistInd === 'N'"
                (click)="getsubjectData(MT.ID,'C',i)">
                <i class="fa fa-angle-right" *ngIf="!MT.Data"></i><i class="fa fa-angle-down" *ngIf="MT.Data"></i>
              </button>
            </div>
            <app-tree-content Text="{{MT.Name}}" status="{{MT.Status_Code}}" ID="{{MT.ID}}"
              (mouseenter)="OnSelect(MT.ID,MT.Subject_Level_Type_Code)"></app-tree-content>
            <div class="px-1  tree-btn-1" (mouseenter)="OnSelect(MT.ID,MT.Subject_Level_Type_Code)">
              <button type="button" class="tree-btn" (click)="EditSubject(MT,'MT',null)"
                *ngIf="enableedit && selectedvalue==MT.ID && selectedkey === 'MT'">
                <i class="fa fa-edit"></i>
              </button>
            </div>
          </div>
          <div class="col-12" *ngIf="MT.Data">
            <app-tree-add-btn-child Text="Add Concept" (click)="addNewConcept(MT,'C',i)"
              *ngIf="enableedit && selectedvalue == MT.ID && (selectedkey === 'C' || selectedkey === 'MT')"
              (mouseenter)="OnSelect(MT.ID,'C')"></app-tree-add-btn-child>
            <div class="row tree-row tree-row-child" *ngFor="let C of MT.Data;let j =index;"
              (mouseenter)="OnSelect(C.ID,C.Subject_Level_Type_Code)">
              <div class="col-12">
                <div class="d-flex">
                  <div class="px-1 tree-btn-1">
                    <button type="button" class="tree-btn" (click)="getsubjectData(C.ID,'SC1',i,j)" attr.id="plusC{{i}}"
                      [hidden]="C.ChildNodeExistInd === 'N'">
                      <i class="fa fa-angle-right" *ngIf="!C.Data"></i><i class="fa fa-angle-down" *ngIf="C.Data"></i>
                    </button>
                  </div>
                  <app-tree-content Text="{{C.Name}}" status="{{C.Status_Code}}" ID="{{C.ID}}"
                    (mouseenter)="OnSelect(C.ID,'C')">
                  </app-tree-content>
                  <div class="px-1 tree-btn-1">
                    <button type="button" class="tree-btn" (click)="EditSubject(C,'C',i,j)"
                      (mouseenter)="OnSelect(C.ID,'C')"
                      *ngIf="enableedit && selectedvalue==C.ID && (selectedkey === 'C' || selectedkey=='SCL1')">
                      <i class="fa fa-edit"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-12" *ngIf="C.Data">
                <app-tree-add-btn-child Text="Add Sub Concept 1" (click)="addNewConcept(C,'SC1',i,j)"
                  *ngIf="enableedit && selectedvalue == C.ID && (selectedkey === 'C' || selectedkey === 'SCL1')"
                  (mouseenter)="OnSelect(C.ID,'SCL1')"></app-tree-add-btn-child>
                <div class="row tree-row tree-row-child" *ngFor="let SC1 of C.Data;let k = index"
                  (mouseenter)="OnSelect(SC1.ID,SC1.Subject_Level_Type_Code)">
                  <div class="col-12 d-flex">
                    <div class="px-1 tree-btn-1">
                      <button type="button" (click)="getsubjectData(SC1.ID,'SC2',i,j,k)" attr.id="plusSC1{{i}}"
                        class="tree-btn" [hidden]="SC1.ChildNodeExistInd === 'N'">
                        <i class="fa fa-angle-right" *ngIf="!SC1.Data"></i><i class="fa fa-angle-down"
                          *ngIf="SC1.Data"></i>
                      </button>
                    </div>
                    <app-tree-content Text="{{SC1.Name}}" status="{{SC1.Status_Code}}" ID="{{SC1.ID}}"
                      (mouseenter)="OnSelect(SC1.ID,SC1.Subject_Level_Type_Code)"></app-tree-content>
                    <div class="px-1 tree-btn-1" (mouseenter)="OnSelect(SC1.ID,SC1.Subject_Level_Type_Code)">
                      <button type="button" class="tree-btn" (click)="EditSubject(SC1,'SC1',i,j,k)"
                        *ngIf="enableedit && selectedvalue==SC1.ID && (selectedkey === 'C' || selectedkey === 'SCL1')">
                        <i class="fa fa-edit"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-12" *ngIf="SC1.Data">
                    <app-tree-add-btn-child Text="Add Sub Concept 2" (click)="addNewConcept(SC1,'SC2',i,j,k)"
                      *ngIf="enableedit && selectedvalue == SC1.ID && (selectedkey === 'SCL1' || selectedkey === 'SCL2')"
                      (mouseenter)="OnSelect(SC1.ID,'SCL2')"></app-tree-add-btn-child>

                    <div class="row tree-row tree-row-child" *ngFor="let SC2 of SC1.Data;let l=index"
                      (mouseenter)="OnSelect(SC2.ID,SC2.Subject_Level_Type_Code)">
                      <div class="col-12 d-flex">
                        <div class="px-1 tree-btn-1">
                          <button type="button" class="tree-btn" (click)="getsubjectData(SC2.ID,'SC3',i,j,k,l)"
                            attr.id="plusSC2{{i}}" [hidden]="SC2.ChildNodeExistInd === 'N'">
                            <i class="fa fa-angle-right" *ngIf="!SC2.Data"></i>
                            <i class="fa fa-angle-down" *ngIf="SC2.Data"></i>
                          </button>
                        </div>
                        <app-tree-content Text="{{SC2.Name}}" status="{{SC2.Status_Code}}" ID="{{SC2.ID}}"
                          (mouseenter)="OnSelect(SC2.ID,SC2.Subject_Level_Type_Code)">
                        </app-tree-content>
                        <div class="px-1 tree-btn-1" (mouseenter)="OnSelect(SC2.ID,SC2.Subject_Level_Type_Code)">
                          <button type="button" class="tree-btn" (click)="EditSubject(SC2,'SC2',i,j,k,l)"
                            *ngIf="enableedit && selectedvalue==SC2.ID && (selectedkey === 'SCL2' || selectedkey === 'SCL1')">
                            <i class="fa fa-edit"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-12" *ngIf="SC2.Data">
                        <app-tree-add-btn-child Text="Add Sub Concept 3" (click)="addNewConcept(SC2,'SC3',i,j,k,l)"
                          *ngIf="enableedit && selectedvalue == SC2.ID && (selectedkey === 'SCL3' || selectedkey === 'SCL2')"
                          (mouseenter)="OnSelect(SC2.ID,'SCL3')"></app-tree-add-btn-child>
                        <div class="row tree-row tree-row-child " *ngFor="let SC3 of SC2.Data;let m=index"
                          (mouseenter)="OnSelect(SC3.ID,SC3.Subject_Level_Type_Code)">
                          <div class="col-12 d-flex">
                            <div class="px-1 tree-btn-1">
                              <button type="button" class="tree-btn" (click)="getsubjectData(SC3.ID,'SC4',i,j,k,l,m)"
                                attr.id="plusSC3{{i}}" [hidden]="SC3.ChildNodeExistInd === 'N'">
                                <i class="fa fa-angle-right" *ngIf="!SC3.Data"></i>
                                <i class="fa fa-angle-down" *ngIf="SC3.Data"></i>
                              </button>
                            </div>
                            <app-tree-content Text="{{SC3.Name}}" status="{{SC3.Status_Code}}" ID="{{SC3.ID}}"
                              (mouseenter)="OnSelect(SC3.ID,SC3.Subject_Level_Type_Code)">
                            </app-tree-content>
                            <div class="px-1 tree-btn-1" (mouseenter)="OnSelect(SC3.ID,SC3.Subject_Level_Type_Code)">
                              <button type="button" class="tree-btn" (click)="EditSubject(SC3,'SC3',i,j,k,l,m)"
                                *ngIf="enableedit  && selectedvalue==SC3.ID && (selectedkey === 'SCL3' || selectedkey === 'SCL2')">
                                <i class="fa fa-edit"></i>
                              </button>
                            </div>
                          </div>
                          <div class="col-12" *ngIf="SC3.Data">
                            <app-tree-add-btn-child Text="Add Sub Concept 4"
                              (click)="addNewConcept(SC3,'SC4',i,j,k,l,m)"
                              *ngIf="enableedit && selectedvalue == SC3.ID && (selectedkey === 'SCL3' || selectedkey === 'SCL4')"
                              (mouseenter)="OnSelect(SC3.ID,'SCL4')"></app-tree-add-btn-child>
                            <div class="row tree-row tree-row-child" *ngFor="let SC4 of SC3.Data;let n=index"
                              (mouseenter)="OnSelect(SC4.ID,SC4.Subject_Level_Type_Code)">
                              <div class="col-12 d-flex">
                                <div class="px-1 tree-btn-1">
                                  <button type="button" class="tree-btn"
                                    (click)="getsubjectData(SC4.ID,'SC5',i,j,k,l,m,n)"
                                    [hidden]="SC4.ChildNodeExistInd === 'N'">
                                    <i class="fa fa-angle-right" *ngIf="!SC4.Data"></i>
                                    <i class="fa fa-angle-down" *ngIf="SC4.Data"></i>
                                  </button>
                                </div>
                                <app-tree-content Text="{{SC4.Name}}" status="{{SC4.Status_Code}}" ID="{{SC4.ID}}"
                                  (mouseenter)="OnSelect(SC4.ID,SC4.Subject_Level_Type_Code)"></app-tree-content>
                                <div class="px-1 tree-btn-1"
                                  (mouseenter)="OnSelect(SC4.ID,SC4.Subject_Level_Type_Code)">
                                  <button type="button" class="tree-btn" (click)="EditSubject(SC4,'SC4',i,j,k,l,m,n)"
                                    *ngIf="enableedit && selectedvalue==SC4.ID && (selectedkey === 'SCL3' || selectedkey === 'SCL4')"
                                    (mouseenter)="OnSelect(SC4.ID,SC4.Subject_Level_Type_Code)">
                                    <i class="fa fa-edit"></i>
                                  </button>
                                </div>
                              </div>
                              <div class="col-12 " *ngIf="SC4.Data">
                                <app-tree-add-btn-child Text="Add Sub Concept 5"
                                  (click)="addNewConcept(SC4,'SC5',i,j,k,l,m,n)"
                                  *ngIf="enableedit && selectedvalue == SC4.ID && (selectedkey === 'SCL5' || selectedkey === 'SCL4')"
                                  (mouseenter)="OnSelect(SC4.ID,'SCL5')"></app-tree-add-btn-child>
                                <div class="row tree-row tree-row-child" *ngFor="let SC5 of SC4.Data;let o=index"
                                  (mouseenter)="OnSelect(SC5.ID,SC5.Subject_Level_Type_Code)">
                                  <div class="col-12 d-flex">
                                    <div class=" px-1 tree-btn-1">
                                      <button type="button" class="tree-btn"
                                        (click)="getsubjectData(SC5.ID,'SC6',i,j,k,l,m,n,o)"
                                        [hidden]="SC5.ChildNodeExistInd === 'N'">
                                        <i class="fa fa-angle-right" *ngIf="!SC5.Data"></i>
                                        <i class="fa fa-angle-down" *ngIf="SC5.Data"></i>
                                      </button>
                                    </div>
                                    <app-tree-content Text="{{SC5.Name}}" status="{{SC5.Status_Code}}" ID="{{SC5.ID}}"
                                      (mouseenter)="OnSelect(SC5.ID,SC5.Subject_Level_Type_Code)"></app-tree-content>
                                    <div class="px-1 tree-btn-1"
                                      (mouseenter)="OnSelect(SC5.ID,SC5.Subject_Level_Type_Code)">
                                      <button type="button" class="tree-btn"
                                        (click)="EditSubject(SC5,'SC5',i,j,k,l,m,n,o)"
                                        *ngIf="enableedit && selectedvalue==SC5.ID && (selectedkey === 'SCL5' || selectedkey === 'SCL4')"
                                        (mouseenter)="OnSelect(SC5.ID,SC5.Subject_Level_Type_Code)">
                                        <i class="fa fa-edit"></i>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-12 " *ngIf="SC5.Data">
                                    <app-tree-add-btn-child Text="Add Sub Concept 6"
                                      (click)="addNewConcept(SC5,'SC6',i,j,k,l,m,n,o)"
                                      *ngIf="enableedit && selectedvalue == SC5.ID && (selectedkey === 'SCL5' || selectedkey === 'SCL6')"
                                      (mouseenter)="OnSelect(SC5.ID,'SCL6')"></app-tree-add-btn-child>
                                    <div class="row tree-row tree-row-child" *ngFor="let SC6 of SC5.Data;let p=index"
                                      (mouseenter)="OnSelect(SC6.ID,SC6.Subject_Level_Type_Code)">
                                      <div class="col-12 d-flex">
                                        <div class="px-1 tree-btn-1">
                                          <button type="button" class="tree-btn"
                                            [hidden]="SC6.ChildNodeExistInd === 'N'">
                                            <i class="fa fa-angle-right" *ngIf="!SC6.Data"></i>
                                            <i class="fa fa-angle-down" *ngIf="SC6.Data"></i>
                                          </button>
                                        </div>
                                        <app-tree-content Text="{{SC6.Name}}" status="{{SC6.Status_Code}}"
                                          ID="{{SC6.ID}}" (mouseenter)="OnSelect(SC6.ID,SC6.Subject_Level_Type_Code)">
                                        </app-tree-content>
                                        <div class="px-1 tree-btn-1"
                                          (mouseenter)="OnSelect(SC6.ID,SC6.Subject_Level_Type_Code)">
                                          <button type="button" class="tree-btn"
                                            (click)="EditSubject(SC6,'SC6',i,j,k,l,m,n,o,p)"
                                            *ngIf="enableedit && selectedvalue==SC6.ID && (selectedkey === 'SCL5' || selectedkey === 'SCL6')"
                                            (mouseenter)="OnSelect(SC6.ID,SC6.Subject_Level_Type_Code)">
                                            <i class="fa fa-edit"></i>
                                          </button>
                                        </div>
                                      </div>
                                      <!-- <div class="col-12"
                                        *ngIf="SC5.ChildNodeExistInd === 'N' && enableedit && selectedvalue==SC5.ID && (selectedkey === 'SCL6' || selectedkey === 'SCL5')">
                                        <app-tree-add-btn-child (click)="addNewConcept(SC5,'SC6',i,j,k,l,m,n,o)"
                                          *ngIf="enableedit && selectedvalue == SC5.ID && (selectedkey === 'SCL6' || selectedkey === 'SCL5')"
                                          (mouseenter)="OnSelect(SC5.ID,'SCL6')" Text="Add Sub Concept 6" [Primary]=0>
                                        </app-tree-add-btn-child>
                                      </div> -->
                                    </div>
                                  </div>
                                  <div class="col-12"
                                  *ngIf="SC5.ChildNodeExistInd === 'N' && enableedit && selectedvalue==SC5.ID && (selectedkey === 'SCL6' || selectedkey === 'SCL5')">
                                  <app-tree-add-btn-child (click)="addNewConcept(SC5,'SC6',i,j,k,l,m,n,o)"
                                    *ngIf="enableedit && selectedvalue == SC5.ID && (selectedkey === 'SCL6' || selectedkey === 'SCL5')"
                                    (mouseenter)="OnSelect(SC5.ID,'SCL6')" Text="Add Sub Concept 6" [Primary]=0>
                                  </app-tree-add-btn-child>
                                </div>
                                </div>
                              </div>
                              <div class="col-12"
                                *ngIf="SC4.ChildNodeExistInd === 'N' && enableedit && selectedvalue==SC4.ID && (selectedkey === 'SCL5' || selectedkey === 'SCL4')">
                                <app-tree-add-btn-child (click)="addNewConcept(SC4,'SC5',i,j,k,l,m,n)"
                                  *ngIf="enableedit && selectedvalue == SC4.ID && (selectedkey === 'SCL4' || selectedkey === 'SCL5')"
                                  (mouseenter)="OnSelect(SC4.ID,'SCL5')" Text="Add Sub Concept 5" [Primary]=0>
                                </app-tree-add-btn-child>
                              </div>
                            </div>
                          </div>
                          <div class="col-12"
                            *ngIf="SC3.ChildNodeExistInd === 'N' && enableedit && selectedvalue==SC3.ID && (selectedkey === 'SCL4' || selectedkey === 'SCL3')">
                            <app-tree-add-btn-child (click)="addNewConcept(SC3,'SC4',i,j,k,l,m)"
                              *ngIf="enableedit && selectedvalue == SC3.ID && (selectedkey === 'SCL4' || selectedkey === 'SCL3')"
                              (mouseenter)="OnSelect(SC3.ID,'SCL4')" Text="Add Sub Concept 4" [Primary]=0>
                            </app-tree-add-btn-child>
                          </div>
                        </div>
                      </div>
                      <div class="col-12"
                        *ngIf="SC2.ChildNodeExistInd === 'N' && enableedit && selectedvalue==SC2.ID && (selectedkey === 'SCL2' || selectedkey === 'SCL3')">
                        <app-tree-add-btn-child (click)="addNewConcept(SC2,'SC3',i,j,k,l)"
                          *ngIf="enableedit && selectedvalue == SC2.ID && (selectedkey === 'SCL2' || selectedkey === 'SCL3')"
                          (mouseenter)="OnSelect(SC2.ID,'SCL3')" Text="Add Sub Concept 3" [Primary]=0>
                        </app-tree-add-btn-child>
                      </div>
                    </div>
                  </div>
                  <div class="col-12"
                    *ngIf="SC1.ChildNodeExistInd === 'N' && enableedit && selectedvalue==SC1.ID && (selectedkey === 'SCL2' || selectedkey === 'SCL1')">
                    <app-tree-add-btn-child (click)="addNewConcept(SC1,'SC2',i,j,k)"
                      *ngIf="enableedit && selectedvalue == SC1.ID && (selectedkey === 'SCL2' || selectedkey === 'SCL1')"
                      (mouseenter)="OnSelect(SC1.ID,'SCL2')" Text="Add Sub Concept 2" [Primary]=0>
                    </app-tree-add-btn-child>
                  </div>
                </div>
              </div>
              <div class="col-12"
                *ngIf="C.ChildNodeExistInd === 'N' && enableedit && selectedvalue==C.ID && (selectedkey === 'C' || selectedkey === 'SCL1')">
                <app-tree-add-btn-child (click)="addNewConcept(C,'SC1',i,j)"
                  *ngIf="enableedit && selectedvalue == C.ID && (selectedkey === 'C' || selectedkey === 'SCL1')"
                  (mouseenter)="OnSelect(C.ID,'SCL1')" Text="Add Sub Concept 1" [Primary]=0></app-tree-add-btn-child>
              </div>
            </div>
          </div>
          <div class="col-12"
            *ngIf="MT.ChildNodeExistInd === 'N' && enableedit && selectedvalue==MT.ID && (selectedkey === 'MT' || selectedkey === 'C')">
            <app-tree-add-btn-child (click)="addNewConcept(MT,'C',i)"
              *ngIf="enableedit && selectedvalue == MT.ID && (selectedkey === 'C' || selectedkey === 'MT')"
              (mouseenter)="OnSelect(MT.ID,'C')" Text="Add Concept" [Primary]=0></app-tree-add-btn-child>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 text-center mt-3 pt-3" *ngIf="MajorTopic && MajorTopic.length == 0">
        Select Subject
      </div> -->
    </div>



  </div>
</div>
<div class="row">
  <app-subject-breakdown-add-edit   *ngIf="Addnewsubject||Editsubjectflag"
  [statusvalidate]=statusvalidate
                [enableedit]=enableedit
                [Editsubjectflag]=Editsubjectflag
                 [Breadcrumblist]=Breadcrumblist
                 [subjectcode]=subjectcode
                 [Addform]=Addform
                 [EditedForm]=EditedForm
                  [subject]=subject
                 [MajorTopic]=MajorTopic
                 (getsubjectId)="getsubjectId($event)"
                 [hideStatus]=hideStatus
                 [Reload]=Reload
                 [EditedForm]=EditedForm
                 [Addnewsubject]=Addnewsubject
                 [subjectById]=subjectById
                 [ngSelect]=ngSelect
                 [ngSelect1]=ngSelect1
                 [ResourceAssignEnabled]=ResourceAssignEnabled
                 [Disbletranslation]=Disbletranslation
                 [bracketscheckbox]=bracketscheckbox
                 [Descriptionvalue]=Descriptionvalue
                 (reset1)="reset($event)"
                 [Refresh]=Refresh
                 (getsubjectDataRefresh)="getsubjectDataRefresh($event)"
               ></app-subject-breakdown-add-edit>



</div>
